import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_FACETS_GET_PATH } from "../tars-constants";

export interface GetFacetPayload {
  facet_id: number;
  key?: string;
}

export const useGetFacet = () => {
  const rootStore = useStore();

  return useMutation({
    mutationFn: async (payload: GetFacetPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_FACETS_GET_PATH,
        payload,
        "Failed to fetch facet"
      );
      return res.data ?? res;
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to fetch facet"));
    },
  });
};
